var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ListMenuCategory',{staticClass:"mt-4",on:{"category":function($event){_vm.$store.state.selectedCategory = $event}}}),_c('transition-group',{staticClass:"d-flex flex-wrap justify-space-between mt-12 pb-12 card-list",attrs:{"tag":"div"}},_vm._l((_vm.filterdCategories),function(menu){return _c('router-link',{key:menu.menutitle,staticStyle:{"text-decoration":"none"},attrs:{"to":{
        name: 'menu',
        params: {
          id: menu.menutitle,
          menuImgUrl: menu.imageUrl,
          menuTitle: menu.menutitle,
          menuContents: menu.menucontents,
        },
      }}},[_c('ListMenuItem',{attrs:{"menu-img-url":menu.imageUrl,"menu-title":_vm.$store.state.localeEn ? menu.menutitle_en : menu.menutitle}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }